import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave, faUserTie, faInfoCircle, faHistory } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Pessoa() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { get, post, put } = useFetch();
    const location = useLocation();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        dados: { 
            nome: "", cargo_funcao: "", periodo_atuacao: "", 
            departamento: "", instituicao: "", observacoes: "" 
        }
    });

    useEffect(() => {
        if (id !== "criar") {
            get(`/pessoaretratada/${id}`).then(r => {
                if (r.ok) setState(s => ({ ...s, dados: r.result.data }));
            });
        }
    }, [id]);

    const salvar = async () => {
        const method = id === "criar" ? post : put;
        const url = id === "criar" ? '/pessoaretratada' : `/pessoaretratada/${id}`;
        const response = await method(url, state.dados);
        if (response.ok) {
            Swal.fire({ title: "Registro salvo!", icon: "success", confirmButtonColor: "#587b7f" });
            navigate("/admin/iconografico/pessoas");
        } else {
            Swal.fire({ title: "Não foi possível salvar o registro", icon: "error", confirmButtonColor: "#587b7f" });
        }
    };

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/pessoas" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Pessoa Retratada</h2>
                            <p className="admin-subtitle small mb-0">Identificação biográfica para indexação de imagens</p>
                        </div>
                    </div>

                    <Form>
                        {/* GRUPO 1: DADOS PESSOAIS E CARGO */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faUserTie} className="me-2 text-teal" />
                            <span>Informações Profissionais</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">* Nome Completo</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    value={state.dados.nome} 
                                    onChange={e => setState({...state, dados: {...state.dados, nome: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Período de Atuação</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    placeholder="Ex: 1980 - 1995"
                                    value={state.dados.periodo_atuacao} 
                                    onChange={e => setState({...state, dados: {...state.dados, periodo_atuacao: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Cargo / Função Principal</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    value={state.dados.cargo_funcao} 
                                    onChange={e => setState({...state, dados: {...state.dados, cargo_funcao: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {/* GRUPO 2: INSTITUIÇÃO */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faHistory} className="me-2 text-teal" />
                            <span>Vínculo Institucional</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Instituição</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    value={state.dados.instituicao} 
                                    onChange={e => setState({...state, dados: {...state.dados, instituicao: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Departamento</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    value={state.dados.departamento} 
                                    onChange={e => setState({...state, dados: {...state.dados, departamento: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {/* GRUPO 3: OBSERVAÇÕES */}
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faInfoCircle} className="me-2 text-teal" />
                            <span>Notas Adicionais</span>
                        </div>
                        <div className="row g-4">
                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">Observações Biográficas</Form.Label>
                                <Form.Control 
                                    as="textarea" rows={4}
                                    className="input-moderno" 
                                    value={state.dados.observacoes} 
                                    onChange={e => setState({...state, dados: {...state.dados, observacoes: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Registro
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}